import { createFileRoute } from '@tanstack/react-router'
import { DeleteAccountSuccess } from '@/pages/account/components/DeleteAccountSuccess'

export const Route = createFileRoute('/delete-account-success')({
  component: RouteComponent,
})

function RouteComponent() {
  return <DeleteAccountSuccess />
}
